module.exports = __webpack_public_path__ + "media/images/sales/early/icon-apply-01-f74ea5ddab87c3c8c5786c69f2dc0598.svg";